import { useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { useLocation } from '@redwoodjs/router';

import { useAuthContext } from 'src/contexts/AuthProvider';

import './index.css';

import { getRouteHeader } from 'src/menu-items/pages';

import { ProfileSection } from '../ProfileSection';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
    const { user } = useAuthContext();
    const location = useLocation();

    const locationHeader = useMemo(() => {
        return getRouteHeader(location.pathname);
    }, [location]);

    return (
        <Box className="navbar-container" borderRadius="16px">
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                borderRadius="16px"
                padding="24px"
                className="navbar"
            >
                <Box>
                    <Typography fontWeight={700} fontSize="24px" lineHeight="34px" color="#ffffff">
                        {user?.firstName ? `Hi ${user?.firstName}` : 'Hi,'}
                    </Typography>
                    <Typography
                        fontWeight={400}
                        fontSize="16px"
                        lineHeight="22.8px"
                        color="#ffffff"
                    >
                        {locationHeader}
                    </Typography>
                </Box>
                <Box
                    bgcolor="#FFEA99"
                    borderRadius="25px"
                    padding="8px"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <ProfileSection />
                </Box>
            </Box>
        </Box>
    );
};
